import { FxIdApplicationStoreCreatePaymentHandlerEmbeddingType, FxIdDomainModelsDBStoreDBOrderOptimisticUserStatus, FxIdDomainStoreEnumsSupportedWebPublishingPlatform } from "@fxid/openapi-client";
import OpenApiClient from "@fxid/openapi-client";
import { EFxIdSdkAdapterInfoSocialCapability, EFxIdSdkGender, FxIdSdkAdapterSocialSettingDefault } from "@fxid/sdk-core";
import { getAuthToken } from "@fxid/shared";
import i18next from "i18next";
import { chunk } from "lodash-es";
import { deferred } from "../types/FxIdSdkUtils";
import { FxIdSdkBaseAdapter } from "./FxIdSdkBaseAdapter";
export class FxIdSdkAdapterForOk extends FxIdSdkBaseAdapter {
    constructor(exportedSdk, game, config, os, isMobile, dependencies) {
        super(exportedSdk, game, config, dependencies);
        this.exportedSdk = exportedSdk;
        this.game = game;
        this.config = config;
        this.os = os;
        this.isMobile = isMobile;
        this.adapter = "ok";
        this.defaultSocialSettings = {
            ...FxIdSdkAdapterSocialSettingDefault,
            ui: {
                ...FxIdSdkAdapterSocialSettingDefault.ui,
                disabled: false
            }
        };
        this._adAvailable = false;
        this._TOP_PANEL_HEIGHT = 48;
        this._innerHeight = 0;
        this._PAGE_INFO_REFRESH_INTERVAL_MS = 5000;
        window.API_callback = this.ApiCallback.bind(this);
        this.getPageInfoResolve = async (data) => {
            const dataStr = typeof data === "string" ? data : await data;
            try {
                const pageData = JSON.parse(dataStr);
                if (this._innerHeight !== pageData.innerHeight) {
                    log.info("Updating window size");
                    this._innerHeight = pageData.innerHeight;
                    FAPI.UI.setWindowSize(pageData.innerWidth, pageData.innerHeight);
                    FAPI.UI.scrollTo(0, this._TOP_PANEL_HEIGHT);
                }
            }
            catch (error) {
                log.error("Error while parsing getPageInfo response!", error);
            }
        };
    }
    RegisterShareHandlers() {
        // NOTE: На мобильном ВК окно showInvite может не вызваться если нет друзей и просто ничего не покажется,
        // придет колбек в API_Callback (ниже)
        // TODO: Надо будет делать спец окно "нет друзей для пришлашения"
        // https://apiok.ru/dev/sdk/js/ui.showInvite/
        if (!this.isMobile) {
            const sharingHandler = this._dependencies.getSharingHandler();
            if (sharingHandler) {
                sharingHandler.enableShareOk?.(() => {
                    // FAPI.UI.postMediatopic(
                    // 	{
                    // 		media: [
                    // 			{
                    // 				type: "text",
                    // 				text: i18next.t(`seo.${this.game}.description`)
                    // 			},
                    // 			{
                    // 				type: "link",
                    // 				url: `https://ok.ru/game/${this.config.PlatformData.Odnoklassniki!.AppId}`
                    // 			}
                    // 		]
                    // 	},
                    // 	false
                    // );
                    const text = i18next.t(`seo.${this.game}.invite`);
                    log.info("Sharing with text %s", text);
                    const callback = (status, _result, data) => {
                        const result = _result;
                        log.info("Friends.get callback. Status: %o, result: %o, data: %o", status, result, data);
                        if (result.length > 0) {
                            FAPI.UI.showInvite(text, "", result[0]);
                            // в случае успеха возвращает в API_callback третьим параметром строку, в которой через запятую указаны id приглашенных друзей
                        }
                        else {
                            FAPI.UI.showInvite(text);
                        }
                    };
                    FAPI.Client.call({ method: "friends.get" }, callback);
                });
            }
        }
        else {
            log.info("OK invite currently disabled on mobile");
        }
        return Promise.resolve();
    }
    ApiCallback(method, result, data) {
        log.info(`Api callback: method: %s, result: %s, data: %o`, method, result, data);
        switch (method) {
            case "showPayment":
                if (result !== "ok") {
                    this.buyProductReject?.call(this, { error: JSON.stringify({ result: result, data: data }) });
                }
                else {
                    this.buyProductResolve?.call(this, {});
                }
                return;
            case "loadAd":
                if (result !== "ok") {
                    this._adAvailable = false;
                    this.loadAdReject?.call(this, data);
                }
                else {
                    this._adAvailable = true;
                    this.exportedSdk.DispatchAdsVideoAvailable();
                    this.loadAdResolve?.call(this, data);
                }
                return;
            case "showAd":
                if (result === "ok") {
                    this.exportedSdk.DispatchAdsFinished();
                }
                else {
                    this.exportedSdk.DispatchAdsFailed();
                }
                break;
            case "showLoadedAd":
                if (result !== "ok") {
                    if (data === "skip") {
                        this.exportedSdk.DispatchAdsSkipped();
                    }
                    else {
                        this.exportedSdk.DispatchAdsFailed();
                    }
                    this.showAdReject?.call(this, data);
                }
                else {
                    // Просим загрузить еще
                    FAPI.UI.loadAd();
                    this.exportedSdk.DispatchAdsFinished();
                    this.showAdResolve?.call(this, data);
                }
                return;
            case "getPageInfo":
                if (result !== "ok") {
                    this.getPageInfoReject?.call(this, data);
                }
                else {
                    void this.getPageInfoResolve?.call(this, data);
                }
                return;
            case "showNotification":
                if (result !== "ok") {
                    this.showNotificationReject?.call(this, data);
                }
                else {
                    this.showNotificationResolve?.call(this, data);
                }
                return;
            case "showInvite":
                log.info("Show invite received result: %o", method);
                if (result !== "ok") {
                    this._dependencies.openInfoModal({ title: "Внимание", message: "Нет доступных для приглашения друзей" });
                }
                return;
            case "showRatingDialog":
                log.info("Show rating dialog received result: %o", method);
                if (result !== "ok") {
                    this.showRatingDialogReject?.call(this, data);
                }
                else {
                    this.showRatingDialogResolve?.call(this, data);
                }
                return;
            default:
                log.info("Unsupported method in API callback: %o", method);
        }
    }
    CanReview() {
        return Promise.resolve({ canReview: true });
    }
    async RequestReview() {
        FAPI.UI.showRatingDialog();
        const { promise, resolve, reject } = deferred();
        this.showRatingDialogResolve = resolve;
        this.showRatingDialogReject = reject;
        try {
            await promise;
            return Promise.resolve({ shown: true });
        }
        catch (error) {
            log.error("Error requesting review:", error);
        }
        return Promise.resolve({ shown: false });
    }
    getUserRating() {
        return new Promise((resolve, reject) => {
            const callback = (status, data, error) => {
                if (status === "ok" && data != null) {
                    const ratingData = data;
                    log.info("User rating received:", ratingData);
                    resolve(ratingData);
                }
                else {
                    log.error("Error getting user rating:", error);
                    resolve(undefined); // Возвращаем undefined при ошибке, а не reject, чтобы соответствовать логике
                }
            };
            FAPI.Client.call({
                method: "apps.getAppUserRating"
            }, callback);
        });
    }
    async ReviewInfo() {
        try {
            const userRating = await this.getUserRating();
            return (userRating ?? {
                isRatingAvailable: false
            });
        }
        catch (error) {
            log.error("Error getting rating info:", error);
            return {
                isRatingAvailable: false
            };
        }
    }
    async BuyProduct(request) {
        const paymentRequest = {
            Token: getAuthToken(),
            Game: this.game,
            Sku: request.sku,
            WebPublishingPlatform: FxIdDomainStoreEnumsSupportedWebPublishingPlatform.Odnoklassniki,
            EmbeddingType: FxIdApplicationStoreCreatePaymentHandlerEmbeddingType.Embed,
            ProductDescriptionHint: request.productDescriptionHint,
            ProductNameHint: request.productNameHint
        };
        if (request.developerPayload != null) {
            paymentRequest.DeveloperPayload = {
                MerchantDeveloperPayload: request.developerPayload
            };
        }
        const createPaymentResult = await OpenApiClient.Store.fxIdWebFeaturesStoreCreatePaymentEndpoint(paymentRequest);
        log.info("Received result from server: %o", createPaymentResult);
        const { promise, resolve, reject } = deferred();
        this.buyProductResolve = (data) => {
            OpenApiClient.Store.fxIdWebFeaturesStoreOrdersSetOptimisticOrderStatusSetOptimisticOrderStatusEndpoint({
                PublicOrderId: createPaymentResult.TransactionId,
                Status: FxIdDomainModelsDBStoreDBOrderOptimisticUserStatus.Completed
            }).catch((e) => log.error("[OK] Failed to set optimistic status:", e));
            resolve({
                ...data,
                transactionId: createPaymentResult.TransactionId,
                stats: {
                    currency: createPaymentResult.OrderProduct.Currency ?? "",
                    currencyAmount: createPaymentResult.OrderProduct.Price ?? 0,
                    usdAmount: createPaymentResult.OrderProduct.UsdPrice ?? 0
                }
            });
        };
        this.buyProductReject = (data) => {
            OpenApiClient.Store.fxIdWebFeaturesStoreOrdersSetOptimisticOrderStatusSetOptimisticOrderStatusEndpoint({
                PublicOrderId: createPaymentResult.TransactionId,
                Status: FxIdDomainModelsDBStoreDBOrderOptimisticUserStatus.Cancelled
            }).catch((e) => log.error("[OK] Failed to set optimistic status:", e));
            reject(data);
        };
        const orderProduct = createPaymentResult.OrderProduct;
        FAPI.UI.showPayment(request.productNameHint ?? orderProduct.LocalizedProductName, request.productDescriptionHint ?? orderProduct.LocalizedProductDescription, orderProduct.Sku, orderProduct.Price, null, createPaymentResult.Odnoklassniki.ExtraAttributes, undefined, "true");
        return promise;
    }
    async GetSocialInfo() {
        const rParams = FAPI.Util.getRequestParameters();
        const userInfo = await this.OkGetCurrentUser();
        const gender = this.MapOkGender(userInfo.gender);
        return Promise.resolve({
            social: FxIdDomainStoreEnumsSupportedWebPublishingPlatform.Odnoklassniki,
            paymentsAvailable: true,
            userId: rParams.logged_user_id.toString(),
            firstName: userInfo.first_name,
            lastName: userInfo.last_name,
            photo: {
                width: 224,
                height: 224,
                url: userInfo.pic224x224
            },
            gender,
            capabilities: [
                EFxIdSdkAdapterInfoSocialCapability.FriendsList,
                EFxIdSdkAdapterInfoSocialCapability.FriendsInvite,
                EFxIdSdkAdapterInfoSocialCapability.OutgoingLinksForbidden,
                EFxIdSdkAdapterInfoSocialCapability.AdsAvailable,
                EFxIdSdkAdapterInfoSocialCapability.RateApplication
            ]
        });
    }
    async Initialize() {
        log.info("Initializing OK adapter");
        // Load the SDK's source Asynchronously
        await new Promise((resolve) => {
            const s = document.createElement("script");
            s.type = "text/javascript";
            s.src = "//api.ok.ru/js/fapi5.js";
            s.addEventListener("load", function (_e) {
                log.info("Script loaded");
                resolve();
            }, false);
            const head = document.getElementsByTagName("head")[0];
            head.appendChild(s);
            log.info("Script added");
        });
        log.info("Initializing api");
        const rParams = FAPI.Util.getRequestParameters();
        // const displayName = rParams.user_name == null ? `#${rParams.logged_user_id}` : `${rParams.user_name} (#{})`
        const displayName = `#${rParams.logged_user_id}`;
        if (rParams.logged_user_id !== undefined)
            this._dependencies.setUserId(rParams.logged_user_id);
        this._dependencies.setUserDisplayName(displayName);
        await new Promise((resolve, reject) => {
            FAPI.init(rParams.api_server, rParams.apiconnection, 
            /*
             * Первый параметр:
             * функция, которая будет вызвана после успешной инициализации.
             */
            () => {
                log.info("FAPI initialized");
                setInterval(() => FAPI.UI.getPageInfo(), this._PAGE_INFO_REFRESH_INTERVAL_MS);
                log.info(`Requesting page info from OK every ${this._PAGE_INFO_REFRESH_INTERVAL_MS}ms`);
                resolve();
                // здесь можно вызывать методы API
            }, 
            /*
             * Второй параметр:
             * функция, которая будет вызвана, если инициализация не удалась.
             */
            function (error) {
                log.error("FAPI failed to initialize: %o", error);
                reject(error);
            });
        });
        void this.LoadVideoAds();
    }
    LoadVideoAds() {
        FAPI.UI.loadAd();
    }
    StoreCurrency() {
        return Promise.resolve(undefined);
    }
    async StatInitialize(request) {
        return Promise.resolve();
    }
    StatEvent(request) {
        return Promise.resolve(undefined);
    }
    AdsIsVideoReady() {
        FAPI.UI.loadAd();
        return Promise.resolve(this._adAvailable);
    }
    AdsShowVideo() {
        FAPI.UI.showLoadedAd();
        return Promise.resolve();
    }
    async GetFriends(request) {
        const okFriendsData = await this.OkFriendsGet();
        const result = { friends: [] };
        for (const okFriendData of okFriendsData) {
            const gender = this.MapOkGender(okFriendData.gender);
            const friend = {
                uid: okFriendData.uid,
                firstName: okFriendData.first_name,
                lastName: okFriendData.last_name,
                gender,
                photo: {
                    width: 224,
                    height: 224,
                    url: okFriendData.pic224x224
                }
            };
            result.friends.push(friend);
        }
        return result;
    }
    OkFriendsGet() {
        return new Promise((resolve, reject) => {
            const GetOkData = async (data) => {
                try {
                    // ok api limit
                    const maxFriendsPerRequest = 100;
                    const chunkedData = chunk(data, maxFriendsPerRequest);
                    let friendsData = [];
                    for (const chunkOfData of chunkedData) {
                        const result = await this.OkGetUsersInfo(chunkOfData);
                        friendsData = friendsData.concat(result);
                    }
                    resolve(friendsData);
                }
                catch (e) {
                    reject(e);
                    return;
                }
            };
            const callback_friends_get = (status, data, error) => {
                try {
                    if (data != null) {
                        void GetOkData(data);
                        return;
                    }
                }
                catch (e) {
                    reject(e);
                    return;
                }
                reject(new Error(JSON.stringify(error)));
            };
            FAPI.Client.call({ method: "friends.get" }, callback_friends_get);
        });
    }
    OkGetUsersInfo(uids) {
        return new Promise((resolve, reject) => {
            const callback_users_getInfo = function (status, data, error) {
                if (data != null) {
                    resolve(data);
                    return;
                }
                reject(new Error(JSON.stringify(error)));
            };
            FAPI.Client.call({
                method: "users.getInfo",
                fields: "uid,first_name,last_name,gender,PIC224X224",
                uids: uids
            }, callback_users_getInfo);
        });
    }
    OkGetCurrentUser() {
        return new Promise((resolve, reject) => {
            const callback_users_getInfo = function (status, data, error) {
                if (data != null) {
                    resolve(data);
                    return;
                }
                reject(new Error(JSON.stringify(error)));
            };
            FAPI.Client.call({
                method: "users.getCurrentUser",
                fields: "uid,first_name,last_name,gender,PIC224X224"
            }, callback_users_getInfo);
        });
    }
    MapOkGender(genderStr) {
        let gender = EFxIdSdkGender.Unspecified;
        if (genderStr == null)
            return gender;
        switch (genderStr.toLowerCase()) {
            case "m":
            case "male":
                gender = EFxIdSdkGender.Male;
                break;
            case "f":
            case "female":
                gender = EFxIdSdkGender.Female;
                break;
        }
        return gender;
    }
    async InviteFriends(request) {
        const friends = await this.GetFriends({});
        const { promise, resolve, reject } = deferred();
        this.showNotificationResolve = resolve;
        this.showNotificationReject = reject;
        FAPI.UI.showNotification(request.inviteText, request.trackString, friends.friends.map((el) => el.uid).join(";"));
        const result = await promise;
        return {
            friends: result.split(",").map((el) => {
                return { uid: el };
            })
        };
    }
    AdsIsInterstitialReady() {
        this.exportedSdk.DispatchAdsInterstitialAvailable();
        return Promise.resolve(true);
    }
    AdsShowInterstitial() {
        FAPI.UI.showAd();
        return Promise.resolve();
    }
}
